import { createContext, useEffect } from 'react'
import { setMonitoredContext } from '@BUP/services/monitor.js'
import { setTrackedUserData } from '@BUP/services/tracker.js'
import BupLoading from '@BUP/components/Loading/Main'
import { useGetCurrentCourses } from '@BUP/hooks/Courses/useGetCurrentCourses'

export const CourseContext = createContext()

// TODO: manage error
export const CourseContextProvider = ({ children }) => {
  const { courses, isLoading } = useGetCurrentCourses()

  // Si el rol es COUNSELOR o ASSISTANT, courses será []
  // Evitar lógica de loader y null para estos casos
  useEffect(() => {
    if (courses && courses.length > 0) {
      setTrackedUserData({ courses: courses.map(registration => registration.course.name) })
      setMonitoredContext('courses', Object.fromEntries(courses.map(({ course }) => ([course.id, course.name]))))
      // return () => removeUserData('courses')
    }
  }, [courses])

  // Si courses es un array vacío, renderizar igual los children
  if (isLoading) return <BupLoading />
  if (Array.isArray(courses) && courses.length === 0) {
    return <CourseContext.Provider value={courses}>{children}</CourseContext.Provider>
  }
  if (!courses) return null

  return (
    <CourseContext.Provider value={courses}>{children}</CourseContext.Provider>
  )
}
